import { render, staticRenderFns } from "./PostalCodes.vue?vue&type=template&id=5529fc7e&"
import script from "./PostalCodes.vue?vue&type=script&lang=ts&"
export * from "./PostalCodes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports